// 这是给支付、网页授权等特殊场景的回跳用的
export function getRedirectHost() {
  return /\.com$/.test(location.host) ? `${location.protocol}//${location.host}` : __HOST__
}